import { httpClient } from '../lib/http-client';
import { Changelog } from '../types';

/**
 * Service para gerenciamento de changelogs
 */
export class ChangelogsService {
  static async getChangelogs(): Promise<Changelog[]> {
    return httpClient.get<Changelog[]>('/api/changelogs');
  }

  static async getChangelog(id: number): Promise<Changelog> {
    return httpClient.get<Changelog>(`/api/changelogs/${id}`);
  }

  static async createChangelog(data: Partial<Changelog>): Promise<Changelog> {
    return httpClient.post<Changelog>('/api/changelogs', data);
  }

  static async updateChangelog(id: number, data: Partial<Changelog>): Promise<Changelog> {
    return httpClient.put<Changelog>(`/api/changelogs/${id}`, data);
  }

  static async deleteChangelog(id: number): Promise<{ success: boolean }> {
    return httpClient.delete<{ success: boolean }>(`/api/changelogs/${id}`);
  }

  static async getChangelogsPorTipo(tipo: string): Promise<Changelog[]> {
    return httpClient.get<Changelog[]>(`/api/changelogs/tipo/${tipo}`);
  }

  static async getChangelogsPorVersao(versao: string): Promise<Changelog[]> {
    return httpClient.get<Changelog[]>(`/api/changelogs/versao/${versao}`);
  }
}

